import React, { useCallback, useEffect, useState } from "react";

import { getAllArticles, getArticleAudio } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, Button, Col, Form, MainPage, Option, Row, Select, TagNormal } from "components";

export const Speech = () => {
  const [loading, setLoading] = useState(true);
  const [verbalizing, setVerbalizing] = useState(false);
  const [articles, setArticles] = useState([]);
  const [article, setArticle] = useState(null);
  const [file, setFile] = useState(null);
  const signal = useCancelAsyncOnUnmount()();

  const updateArticle = (v) => {
    setArticle(v);
  };

  const getAudio = () => {
    setVerbalizing(true);
    setFile(null);
    getArticleAudio({
      signal,
      id: article,
    }).then((res) => {
      // this delay is only necessary because it can take a few seconds for the file to finish processing
      // in production, we should generate files once and save the file path for future use
      setTimeout(() => {
        setFile(res);
        setVerbalizing(false);
      }, 10000);
    });
  };

  const loadAllArticles = useCallback(() => {
    getAllArticles({
      signal,
    })
      .then((res) => {
        setArticles(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllArticles();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={
          <>
            Text to speech <TagNormal text="ALPHA" style={{ transform: "translate(0, -50%)", fontWeight: "bold" }} />
          </>
        }
        description="Select an article to convert into speech. It will only do the first few paragraphs (we pay per character). In production, this process should NOT happen on the fly - instead files should be pre-generated and saved."
      />
      {!loading && (
        <>
          <Form>
            <Row>
              <Col sm={24} md={16}>
                <Select
                  name="field"
                  label="Select article"
                  rules={[{ required: true }]}
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(v) => updateArticle(v)}
                  optionLabelProp={"label"}
                >
                  {articles.map((article, i) => (
                    <Option value={article.id} key={i} label={article.title}>
                      {article.title}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col sm={24} md={6}>
                <Button onClick={() => getAudio()} size="large" type="primary" disabled={!article || verbalizing} loading={verbalizing}>
                  Boom!
                </Button>
              </Col>
            </Row>
          </Form>
          {file && (
            <Row className="margin-top-300">
              <Col sm={24} md={24}>
                <audio controls>
                  <source src={file} type="audio/mpeg" />
                </audio>
              </Col>
            </Row>
          )}
        </>
      )}
    </MainPage>
  );
};
